interface LexicalNode {
  type?: string;
  tag?: string;
  text?: string;
  format?: number | string;
  style?: string;
  textStyle?: string;
  listType?: string;
  url?: string;
  children?: LexicalNode[];
}

interface LexicalContent {
  root?: {children?: LexicalNode[]};
}

export function lexicalToHtml(content: LexicalContent | null | undefined): string {
  if (!content?.root || !Array.isArray(content.root.children)) {
    return "";
  }

  function getAlign(format: string | number | undefined) {
    switch (format) {
      case "center":
        return "center";
      case "right":
        return "right";
      case "justify":
        return "justify";
      default:
        return "left";
    }
  }

  function renderNode(node: LexicalNode): string {
    if (!node) {
      return "";
    }

    // Párrafos
    if (node.type === "paragraph" && Array.isArray(node.children)) {
      const text = node.children.map(renderNode).join("");
      const align = node.format ? `text-align:${getAlign(node.format)};` : "";
      const style = (node.textStyle ? node.textStyle : "") + (node.style ? node.style : "");
      return `<p style="${align}${style}">${text}</p>`;
    }

    // Encabezados
    if (node.type === "heading" && Array.isArray(node.children)) {
      const level = node.tag || "h1";
      const text = node.children.map(renderNode).join("");
      const style = node.style ? ` style="${node.style}"` : "";
      return `<${level}${style}>${text}</${level}>`;
    }

    // Citas
    if (node.type === "quote" && Array.isArray(node.children)) {
      const text = node.children.map(renderNode).join("");
      return `<blockquote>${text}</blockquote>`;
    }

    // Código
    if (node.type === "code") {
      return `<pre><code>${node.text || ""}</code></pre>`;
    }

    // Listas
    if (node.type === "list" && Array.isArray(node.children)) {
      const tag = node.listType === "number" ? "ol" : "ul";
      const items = node.children.map(renderNode).join("");
      return `<${tag}>${items}</${tag}>`;
    }
    if (node.type === "listitem" && Array.isArray(node.children)) {
      const text = node.children.map(renderNode).join("");
      return `<li>${text}</li>`;
    }

    // Enlaces
    if (node.type === "link" && Array.isArray(node.children)) {
      const text = node.children.map(renderNode).join("");
      const url = node.url || "#";
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    }

    if (node.type === "text") {
      let text = node.text || "";

      const markdownLink = text.match(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/);
      if (markdownLink) {
        text = text.replace(
          /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
          `<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>`
        );
      }

      let open = "";
      let close = "";
      if (node.format) {
        const fmt = typeof node.format === "number" ? node.format : 0;
        if (fmt & 1) {
          open += "<strong>";
          close = `</strong>${close}`;
        }
        if (fmt & 2) {
          open += "<em>";
          close = `</em>${close}`;
        }
        // Subrayado
        if (fmt & 4 || fmt & 8) {
          open += "<u>";
          close = `</u>${close}`;
        }
      }
      const style = node.style ? ` style="${node.style}"` : "";
      return `${open}<span${style}>${text}</span>${close}`;
    }

    // Saltos de línea
    if (node.type === "linebreak") {
      return "<br/>";
    }

    return "";
  }

  return content.root.children.map(renderNode).join("");
}
